import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { formatVND } from "../../constants"

// What a POST top-up does to an existing month row. Remaining moves by exactly
// the added amount under either accumulate policy (BE-confirmed).
const BudgetTopUpSummary = ({ row, amount }) => {
  const facts = [
    ["Current total", formatVND(row.total)],
    ["Committed", formatVND(row.committed)],
    ["Approved, unpaid", formatVND(row.approvedUnpaid)],
    ["Approved, paid", formatVND(row.approvedPaid)],
    ["Remaining now", formatVND(row.remaining)],
    ["Adding", `+${formatVND(amount)}`],
    ["New total", formatVND((Number(row.total) || 0) + amount)],
    ["Remaining after", formatVND((Number(row.remaining) || 0) + amount)],
  ]
  return (
    <MDBox p={1.5} borderRadius="lg" bgColor="grey-100">
      {facts.map(([label, value]) => (
        <MDBox key={label} display="flex" justifyContent="space-between" py={0.25}>
          <MDTypography variant="caption" color="text">
            {label}
          </MDTypography>
          <MDTypography variant="caption" fontWeight="medium">
            {value}
          </MDTypography>
        </MDBox>
      ))}
    </MDBox>
  )
}

export default BudgetTopUpSummary
